export default __webpack_public_path__ + "static/DottedMaskZinc-5f11fbc0400e337caed264ec51b8c954.svg";